var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 8,
    viewBox: "0 0 270 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C12.1197 3.35328 22.286 3.7852 32.6832 3.96296C57.9822 4.39551 83.2742 4.66667 108.59 4.66667C135.218 4.66667 161.845 4.66667 188.473 4.66667C201.755 4.66667 214.565 2.7521 227.94 3.37037C234.936 3.69379 241.672 4.66667 248.771 4.66667C255.295 4.66667 262.063 4.14757 268 6",
    stroke: "#8259F7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.efae1dba9b1e430730116b2f54a5fba0.svg";
export { ForwardRef as ReactComponent };